var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"record-diff"},[_vm._v("\n  "+_vm._s(_vm.cur)+"\n  "),(_vm.isDecrease || _vm.isIncrease)?_c('i',{class:['arrow', _vm.arrowClass]},[_vm._v(_vm._s(_vm.diff))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }